import { GeneralSettings } from 'components/voucher/voucher-create/general-settings/GeneralSettings'
import { useEffect, useState } from 'react'
import { constructOptionMultipleSelect } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_VOUCHER } from 'services/apiVoucher'

const VOUCHER_TYPE = [
    {
        label: 'Fixed Cart Discount',
        value: 'fixed-cart-discount',
    },
    {
        label: 'Fixed Product Discount',
        value: 'fixed-product-discount',
    },
    {
        label: 'Shipping Discount',
        value: 'shipping-discount',
    },
    {
        label: 'Free Gift',
        value: 'free-gift',
    },
]

export const GeneralSettingsContainer = ({ sectionRef, voucherDetail, onChangeForm, errorForm }) => {
    const TIME_DEFAULT = '00:00'
    const [date, setDate] = useState({ start: null, end: null })
    const [time, setTime] = useState({ start: null, end: null })
    const { fetching: getGiftList } = useFetch(API_VOUCHER.GIFT_LIST)
    const [options, setOptions] = useState({
        voucher_type: VOUCHER_TYPE,
        gifts: [],
    })

    const onSearchGift = (keyword) => {
        getGiftList({ search: keyword }).then((response) => {
            const newList = constructOptionMultipleSelect(response?.data, 'name', 'id', 'image_url')
            setOptions({ ...options, gifts: newList })
        })
    }

    const onChangeGift = (item) => {
        const newItem = { [item?.name]: item?.value, ...(!item?.value?.length && { is_free_shipping: false }) }
        onChangeForm(newItem)
    }

    const onChangeDateTime = ({ name, value }) => {
        let newItem = {}
        switch (name) {
            case 'start_date':
                newItem = { date_start: value ? `${value} ${time?.start || TIME_DEFAULT}` : null }
                break
            case 'end_date':
                newItem = { date_expires: value ? `${value} ${time?.start || TIME_DEFAULT}` : null }
                break
            case 'start_time':
                newItem = { date_start: `${date?.start} ${value || TIME_DEFAULT}` }
                break
            case 'end_time':
                newItem = { date_expires: `${date?.end} ${value || TIME_DEFAULT}` }
                break
            default:
                return
        }
        onChangeForm(newItem)
    }

    useEffect(() => {
        const splitStartSale = voucherDetail?.date_start?.split(' ')
        const splitEndSale = voucherDetail?.date_expires?.split(' ')
        setDate({ start: splitStartSale?.[0] || null, end: splitEndSale?.[0] || null })
        setTime({ start: splitStartSale?.[1] || null, end: splitEndSale?.[1] || null })
    }, [voucherDetail?.date_start, voucherDetail?.date_expires])

    const props = {
        sectionRef: sectionRef?.general_settings,
        voucherDetail,
        isPercentage: voucherDetail?.discount_type === 'percentage',
        isNominal: voucherDetail?.discount_type === 'nominal',
        options,
        date,
        time,
        voucherType: VOUCHER_TYPE,
        onChangeGift,
        onChangeDateTime,
        onChangeForm,
        onSearchGift,
        errorForm,
    }

    return <GeneralSettings {...props} />
}
